/**
 * The AI's proposals as cards: one field's whole replacement text, or the
 * whole run-of-play, each with the text it would replace beneath it so the
 * change can be compared. "Accepted" is the parent's truth (the text is now
 * in the draft), so it flips back to Accept when the user edits the field.
 */
import React from 'react';
import { Card, Accept } from './FacilitationChat.styles';

function StepsList({ steps, t }) {
  return (
    <ol>
      {steps.map((s, i) => (
        // eslint-disable-next-line react/no-array-index-key -- a run-of-play has no ids; order is identity
        <li key={i}>
          {Number.isInteger(s.minutes) ? <strong>{t('facilitationChat.minutes', { count: s.minutes })} · </strong> : null}
          {s.title ? <strong>{s.title}. </strong> : null}
          {s.text}
        </li>
      ))}
    </ol>
  );
}

function AcceptButton({ accepted, disabled, onAccept, t }) {
  return (
    <Accept type="button" $accepted={accepted} disabled={disabled || accepted} onClick={onAccept}>
      {accepted ? t('facilitationChat.accepted') : t('facilitationChat.accept')}
    </Accept>
  );
}

export function FieldProposalCard({ label, text, original = '', rationale, accepted, disabled, onAccept, t }) {
  return (
    <Card $accepted={accepted}>
      <div className="head">
        <strong>{label}</strong>
        <AcceptButton accepted={accepted} disabled={disabled} onAccept={onAccept} t={t} />
      </div>
      <p className="text">{text}</p>
      <div className="original">
        <span className="label">{t('facilitationChat.original')}</span>
        <p className={original ? 'text' : 'text empty'}>{original || t('facilitationChat.originalEmpty')}</p>
      </div>
      {rationale ? <p className="rationale">{rationale}</p> : null}
    </Card>
  );
}

export function StepsProposalCard({ steps, original = [], rationale, accepted, disabled, warning, onAccept, t }) {
  const total = steps.reduce((sum, s) => sum + (Number.isInteger(s.minutes) ? s.minutes : 0), 0);
  return (
    <Card $accepted={accepted}>
      <div className="head">
        <strong>{t('facilitationChat.stepsProposal')}</strong>
        {total > 0 ? <span>{t('facilitationChat.minutes', { count: total })}</span> : null}
        <AcceptButton accepted={accepted} disabled={disabled} onAccept={onAccept} t={t} />
      </div>
      <StepsList steps={steps} t={t} />
      <div className="original">
        <span className="label">{t('facilitationChat.original')}</span>
        {original.length
          ? <StepsList steps={original} t={t} />
          : <p className="text empty">{t('facilitationChat.originalNoSteps')}</p>}
      </div>
      {rationale ? <p className="rationale">{rationale}</p> : null}
      <p className="warning">{t('facilitationChat.stepsReplace')}{warning ? ` ${warning}` : ''}</p>
    </Card>
  );
}
